import { type LayerEnvironment } from '../../layerEnvironments'

export interface DemoSearchBarProps {
  searchQuery: string
  onSearchChange: (query: string) => void
  recentDemos: string[]
  onSelectRecent: (clientName: string) => void
  onCreateClick: () => void
  showArchived: boolean
  onShowArchivedChange: (showArchived: boolean) => void
}

export interface RawDemoData {
  id: string
  client_name: string
  brand_color_hex: string
  brand_color_light_hex: string
  brand_color_dark_hex: string
  brand_color_text_hex: string
  brand_logo_url: string
  business_id?: string
  date_picker_mode?: string
  has_imported_revenue_data?: boolean
  bookkeeping_on?: boolean
  show_descriptions?: boolean
  show_receipt_uploads?: boolean
  show_invoices_tab?: boolean
  show_customer_vendor?: boolean
  default_to_mobile?: boolean
  use_solopreneur_layout?: boolean
  enable_time_tracking?: boolean
  translate_to_spanish: boolean
  has_credential_override: boolean
  layer_environment_override?: string | null
  archived_at?: string | null
}

export type DateRangeDatePickerModes = 'dayRangePicker' | 'monthPicker'

export interface DemoFormValues {
  brandColorHex: string
  brandColorLightHex: string
  brandColorDarkHex: string
  brandColorTextHex: string
  brandLogoUrl: string
  businessId: string
  bookkeepingOn: boolean
  showDescriptions: boolean
  showReceiptUploads: boolean
  showInvoicesTab: boolean
  showCustomerVendor: boolean
  datePickerMode: DateRangeDatePickerModes | null
  layerEnvironmentOverride: LayerEnvironment | null
  defaultToMobile: boolean
}

export const EMPTY_DEMO_FORM_VALUES: DemoFormValues = {
  brandColorHex: '',
  brandColorLightHex: '',
  brandColorDarkHex: '',
  brandColorTextHex: '',
  brandLogoUrl: '',
  businessId: '',
  bookkeepingOn: false,
  showDescriptions: false,
  showReceiptUploads: false,
  showInvoicesTab: false,
  showCustomerVendor: false,
  datePickerMode: null,
  layerEnvironmentOverride: null,
  defaultToMobile: false,
}

export type DemoFormChange = <K extends keyof DemoFormValues>(
  key: K,
  value: DemoFormValues[K],
) => void

export interface DemoFormFieldsProps {
  values: DemoFormValues
  onChange: DemoFormChange
}
